// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.10.1
//   protoc               v3.21.12
// source: registerreviewer.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Reviewer } from "./schema";

export const protobufPackage = "admin";

export interface RegisterReviewerRequest {
  reviewer: Reviewer | undefined;
  password: string;
}

export interface RegisterReviewerResponse {
}

function createBaseRegisterReviewerRequest(): RegisterReviewerRequest {
  return { reviewer: undefined, password: "" };
}

export const RegisterReviewerRequest: MessageFns<RegisterReviewerRequest> = {
  encode(message: RegisterReviewerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reviewer !== undefined) {
      Reviewer.encode(message.reviewer, writer.uint32(10).fork()).join();
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegisterReviewerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterReviewerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reviewer = Reviewer.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RegisterReviewerRequest {
    return {
      reviewer: isSet(object.reviewer) ? Reviewer.fromJSON(object.reviewer) : undefined,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: RegisterReviewerRequest): unknown {
    const obj: any = {};
    if (message.reviewer !== undefined) {
      obj.reviewer = Reviewer.toJSON(message.reviewer);
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterReviewerRequest>, I>>(base?: I): RegisterReviewerRequest {
    return RegisterReviewerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterReviewerRequest>, I>>(object: I): RegisterReviewerRequest {
    const message = createBaseRegisterReviewerRequest();
    message.reviewer = (object.reviewer !== undefined && object.reviewer !== null)
      ? Reviewer.fromPartial(object.reviewer)
      : undefined;
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseRegisterReviewerResponse(): RegisterReviewerResponse {
  return {};
}

export const RegisterReviewerResponse: MessageFns<RegisterReviewerResponse> = {
  encode(_: RegisterReviewerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RegisterReviewerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRegisterReviewerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RegisterReviewerResponse {
    return {};
  },

  toJSON(_: RegisterReviewerResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RegisterReviewerResponse>, I>>(base?: I): RegisterReviewerResponse {
    return RegisterReviewerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RegisterReviewerResponse>, I>>(_: I): RegisterReviewerResponse {
    const message = createBaseRegisterReviewerResponse();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
